import common from "../../common";
import MiniSignal from "mini-signals";
import ControlMethod from "./ControlMethod";

export default class ControlMethodAI extends ControlMethod
{
    constructor(fighter)
    {
        super(fighter);

        this.intelligence = null;

        this.fireInterval = 0.5;
        this.accumulatedFireInterval = 0;

        this.moveInterval = 1;
        this.accumulatedMoveInterval = 0;

        this.target = {};
        this.lastOptimalTarget = null;

        this.enemy = null;

        this.targetMarker = common.display.circle({radius:5, fillColour:0x000000, visible:false, parent:this.gameScene});

        this.init();
    }

    init()
    {
        if(this.fighter.characterData.enemyData)
        {
            this.intelligence = this.fighter.characterData.enemyData.intelligence;
            var fr = common.config.settings.gamePhysics.ai.fireRate;
            if(fr)
            {
                this.fireInterval = 1 - (fr[0] + (this.fighter.characterData.enemyData.fireRate * (fr[1] - fr[0])));
            }
            this.moveInterval = 1-Math.max(0, Math.min(1, this.intelligence));
        }
        var fighters = this.fighter.gameScene.fighters
        for(var i in fighters)
        {
            if(fighters[i].id !== this.fighter.id)
            {
                this.enemy = fighters[i];
            }
        }
        this.randomRoute();
    }

    destroy()
    { 
        super.destroy();
    }

    update()
    {
        this.accumulatedFireInterval += P3.Ticker.dt * common.timeStretch;

        if(this.accumulatedFireInterval >= this.fireInterval)
        {
            this.accumulatedFireInterval = 0;

            if((this.fighter.y > this.enemy.y + this.enemy.bounds.y && this.fighter.y < this.enemy.y + this.enemy.bounds.y + this.enemy.bounds.height) ||
                       (this.fighter.y + this.fighter.bounds.y > this.enemy.y + this.enemy.bounds.y && this.fighter.y + this.fighter.bounds.y < this.enemy.y + this.enemy.bounds.y + this.enemy.bounds.height))
            {
                this.signals.fireProjectile.dispatch();
            }
            else
            {
                for(var i in this.fighter.trajectoryEstimate)
                {
                    var p = this.fighter.trajectoryEstimate[i];
                    if(this.isPointInsideBounds(this.fighter.x + p.x, this.fighter.y + p.y, this.enemy.x, this.enemy.y, this.enemy.bounds))
                    {
                        this.signals.fireProjectile.dispatch();
                        break;
                    }
                }
            }
        }

        this.accumulatedMoveInterval += P3.Ticker.dt * common.timeStretch;

        if(this.accumulatedMoveInterval >= this.moveInterval && (!this.target.powerup || this.accumulatedMoveInterval > this.moveInterval * 3) )
        {
            this.accumulatedMoveInterval = 0;
            this.optimalRoute();
        }

        //if(this.target && this.target.point)
        //{
            //var b = this.fighter.bounds;
            var padding = this.fighter.y - (this.fighter.y + this.fighter.bounds.y + this.fighter.bounds.height) + 5;

            /*
            if(this.target.powerup &&
               this.target.point.x - padding > this.fighter.x + b.x + (padding*2) &&
               this.target.point.x - padding < this.fighter.x + b.x + b.width + (padding*2) &&
               this.target.point.y - padding > this.fighter.y + b.y + (padding*2) &&
               this.target.point.y - padding < this.fighter.y + b.y + b.height + (padding*2))
            {*/
            if(this.target.powerup && (!this.target.powerup.active || 
               this.isPointInsideBounds(this.target.point.x, this.target.point.y-padding, this.fighter.x, this.fighter.y, this.fighter.bounds) ) )
            {
                /*if(Math.random() < this.aggression || (this.enemy && this.enemy.incapacitated))
                    this.targetRoute();
                else
                    this.randomRoute();*/

                this.optimalRoute();
            }

            var angle = Math.atan2(this.target.point.y - this.fighter.y, this.target.point.x - this.fighter.x);
            if(angle < 0) angle = (2*Math.PI) + angle;

            this.movement.y = Math.sin(angle);
            this.movement.x = Math.cos(angle);
        //}
    }

    randomRoute()
    {
        var rounds = 1;
        var division = 2;
        var field = this.fighter.field;

        var x, y, w, h;

        var points = [];

        for(var r = 0; r < rounds; r++)
        {
            for(var col = 0; col < division; col++)
            {
                for(var row = 0; row < division; row++)
                {
                    x = field.x + ((field.width / division) * col);
                    y = field.y + ((field.height / division) * row);
                    points.push({
                        x: x + ((field.width / division) * Math.random()),
                        y: y + ((field.height / division) * Math.random())
                    });
                }
            }
        }

        this.target = {point:points[Math.floor(points.length * Math.random())]};

        var b = this.fighter.bounds;
        var f = this.fighter.field;
        var p = this.target.point;

        if(p.x + b.x + b.width > f.x + f.width)
        {
            p.x = f.x + f.width - b.x - b.width;
        }
        if(p.x + b.x < f.x)
        {
            p.x = f.x - b.x;
        }
        if(p.y + b.y + b.height > f.y + f.height)
        {
            p.y = f.y + f.height - b.y - b.height;
        }
        if(p.y + b.y < f.y)
        {
            p.y = f.y - b.y;
        }

        this.optimalRoute();
    }

    targetRoute()
    {
        this.randomRoute();
        for(var i in this.fighter.gameScene.fighters)
        {
            var f = this.fighter.gameScene.fighters[i];
            if(f.id !== this.fighter.id)
            {
                this.target.point.y = f.y;
            }
        }
    }

    optimalRoute()
    {
        if(this.enemy.trajectoryEstimate == null || this.fighter.trajectoryEstimate == null)
            return;

        var rounds = 2;
        var division = 4;
        var field = this.fighter.field;

        var x, y;

        var points = [];

        if(this.lastOptimalTarget)
            points.push(this.lastOptimalTarget);

        for(var r = 0; r < rounds; r++)
        {
            for(var col = 0; col < division; col++)
            {
                for(var row = 0; row < division; row++)
                {
                    var x = field.x + ((field.width / division) * col);
                    var y = field.y + ((field.height / division) * row);

                    x += ((field.width / division) * Math.random());
                    y += ((field.height / division) * Math.random());

                    points.push({ x:x, y:y});
                }
            }
        }

        for(var i in points)
        {
            var x = points[i].x;
            var y = points[i].y;

            var b = this.fighter.bounds;
            var f = this.fighter.field;
    
            if(x + b.x + b.width > f.x + f.width)
                x = f.x + f.width - b.x - b.width;
            if(x + b.x < f.x)
                x = f.x - b.x;
            if(y + b.y + b.height > f.y + f.height)
                y = f.y + f.height - b.y - b.height;
            if(y + b.y < f.y)
                y = f.y - b.y;

            var positives = 0;
            for(var j in this.enemy.trajectoryEstimate)
            {
                if(!this.isPointInsideBounds(this.enemy.x + this.enemy.trajectoryEstimate[j].x, this.enemy.y + this.enemy.trajectoryEstimate[j].y, x, y, this.fighter.bounds))
                {
                    positives++;
                }
            }
            var defValue = positives;
            for(var j in this.fighter.trajectoryEstimate)
            {
                if(this.isPointInsideBounds(x + this.fighter.trajectoryEstimate[j].x, y + this.fighter.trajectoryEstimate[j].y, this.enemy.x, this.enemy.y, this.enemy.bounds))
                {
                    positives++;
                }
            }

            points[i].positives = positives;
            points[i].defence = defValue / this.enemy.trajectoryEstimate.length;
            points[i].attack = (positives-defValue) / this.fighter.trajectoryEstimate.length;
            points[i].success = positives / (this.enemy.trajectoryEstimate.length + this.fighter.trajectoryEstimate.length); 
        }

        points.sort((a, b) => 
        {
            if(b.success == a.success)
            {
                if(this.lastOptimalTarget)
                {
                    if(a.x == this.lastOptimalTarget.x && a.y == this.lastOptimalTarget.y)
                        return -1;
                    if(b.x == this.lastOptimalTarget.x && b.y == this.lastOptimalTarget.y)
                        return 1;
                }
                return -1 + (Math.random()*2);
            }

            return b.success - a.success;
        });

        this.target.point = points[0]; 
        this.target.powerup = false;
        this.lastOptimalTarget = points[0];

        this.targetMarker.x = this.target.point.x;
        this.targetMarker.y = this.target.point.y;
    }
    
    powerupRoute(x, y, powerup)
    {
        var field = this.fighter.field;

        this.target.point.x = x + (powerup.hitBox.x * field.direction);
        this.target.point.y = y;
        this.target.powerup = powerup;

        if(this.target.point.x > field.x + field.width)
        {
            this.target.point.x = field.x + field.width;
        }
        if(this.target.point.x < field.x)
        {
            this.target.point.x = field.x;
        }
        if(this.target.point.y > field.y + field.height)
        {
            this.target.point.y = field.y + field.height;
        }
        if(this.target.point.y < field.y)
        {
            this.target.point.y = field.y;
        }

        this.targetMarker.x = this.target.point.x;
        this.targetMarker.y = this.target.point.y;
    }
}